import { DrawerForm } from '@acceso/design-system';
import { useTranslation } from 'react-i18next';

import {
  AppNavbarActionsDrawerFields,
  AppNavbarActionsDrawerProvider,
  useAppNavbarActionsDrawerContext,
} from '.';

export interface AppNavbarActionsDrawerProps {
  isOpen: boolean;
  onSubmit: () => void;
  onCancel: () => void;
}

function AppNavbarActionsDrawer() {
  const { t } = useTranslation();
  const { isOpen, onSubmit, onCancel } = useAppNavbarActionsDrawerContext();

  return (
    <DrawerForm
      title={t('Notificaciones')}
      isOpen={isOpen}
      onSubmit={onSubmit}
      onCancel={onCancel}
      labels={{
        submit: t('Cerrar'),
      }}
    >
      <AppNavbarActionsDrawerFields />
    </DrawerForm>
  );
}

function AppNavbarActionsDrawerNotification(props: AppNavbarActionsDrawerProps) {
  return (
    <AppNavbarActionsDrawerProvider {...props}>
      <AppNavbarActionsDrawer />
    </AppNavbarActionsDrawerProvider>
  );
}

export { AppNavbarActionsDrawerNotification };
